import { useState, useEffect, useCallback } from "react";

import API from "utils/api";
import { useUser } from "utils/hooks";

export default function useAdminUserDetail(id) {
  const { token } = useUser();
  const [result, setResult] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);

  async function fetchAdminUserDetail() {
    setLoading(true);

    const { response, data } = await API.admin.fetchUserDetail(token, id);

    if (response.ok) {
      setError(null);
      setResult(data);
    } else {
      setError(data.message);
      setResult(null);
    }

    setLoading(false);
  }

  useEffect(() => {
    fetchAdminUserDetail();
  }, [id]);

  const refresh = useCallback(() => fetchAdminUserDetail(), [id]);

  return {
    loading,
    error,
    refresh,
    user: result?.user ?? null,
    profile: result?.profile ?? null,
  };
}
